import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
    GetInvoiceDetailRequest,
    GetInvoiceDetailResponse,
    GetInvoiceDetailService,
    ImageViewableStatus
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import {
    DateFnsFormat,
    DateFormat,
    forLifeOf,
    getDynamicRouteLink,
    LifecycleAware,
    ResponsiveService
} from '@lsq-frontend/common-ui';
import { getRouterLinkUrlById, Icons } from '@lsq-frontend/common-ui';
import { ModalService } from '@lsq-frontend/common-ui';
import { PopoverPlacement } from 'ngx-smart-popover';
import { atlas, CUSTOMER_OVERVIEW } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { InvoiceHistoricalImagePreviewModal } from '../invoices.models';
import { InvoiceDetailI18n } from './invoice-detail.i18n';
import { LsqListSource } from '@lsq-frontend/angular-shared/api-service';
import { InvoiceDetailService } from './invoice-detail.service';
import moment from 'moment';

@LifecycleAware()
@Component({
    selector: 'invoice-detail',
    templateUrl: './invoice-detail.component.html',
    styleUrls: ['./invoice-detail.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InvoiceDetailComponent implements OnInit, OnDestroy {
    public invoice: GetInvoiceDetailResponse;
    public lastUpdatedDate: Date;
    public shortDateFormat = DateFormat.LsqShortYear;
    public i18n = InvoiceDetailI18n;
    public initializing = true;
    public request: GetInvoiceDetailRequest;
    public placement = PopoverPlacement;
    public icons = Icons;
    public collectionLink = '/reports/collections?date=';
    public purchaseLink = '/reports/purchases?date=';

    public tableDataSource = new LsqListSource({
        rows$: this._invoiceDetailService.invoiceActivities,
        loading$: this._invoiceDetailService.loading,
        totalCount$: this._invoiceDetailService.totalCount,
        take: this._invoiceDetailService.take.value,
        skip: this._invoiceDetailService.skip.value
    });

    constructor(
        public getInvoiceDetailService: GetInvoiceDetailService,
        private _activatedRoute: ActivatedRoute,
        private _modalService: ModalService,
        public _responsiveService: ResponsiveService,
        private _invoiceDetailService: InvoiceDetailService
    ) {}

    public async ngOnInit(): Promise<void> {
        this._activatedRoute.params.pipe(forLifeOf(this)).subscribe(async (params) => {
            this._invoiceDetailService.getInvoiceDetail(params.invoiceKey);
        });

        this.getInvoiceDetailService.dataStream.pipe(forLifeOf(this)).subscribe((response) => {
            this.lastUpdatedDate = response.lastUpdatedDate;
            this.invoice = response;
            this.initializing = false;
        });

        await this._invoiceDetailService.loadInvoiceActivities();
    }

    public ngOnDestroy(): void {}

    public getOverviewLink(debtorKey: number): string {
        return getDynamicRouteLink(getRouterLinkUrlById(atlas, CUSTOMER_OVERVIEW), { debtorKey });
    }

    public showInvoicePreviewModal(): void {
        this._modalService.showModal(new InvoiceHistoricalImagePreviewModal(this.invoice));
    }

    public get isInvoiceImageViewable(): boolean {
        return this.invoice.imageViewableStatus === ImageViewableStatus.Viewable;
    }

    private _getDateFormat(date: string): string {
        return moment(date).format(DateFnsFormat.ShortFormat);
    }

    public getCollectionURL(date: string): string {
        return this.collectionLink + this._getDateFormat(date);
    }

    public getPurchaseURL(date: string): string {
        return this.purchaseLink + this._getDateFormat(date);
    }
}
